import Lede from './Lede/Lede';
import StoryPackage from './StoryPackage/StoryPackage';

export default {
  lede: Lede,
  story_package: StoryPackage,
  default: StoryPackage,
};
